/**
 * عدد به حروفِ فارسی (v2.173.0) — زیرِ هر فیلدِ مبلغ تا صفرِ اضافه با یک نگاه دیده شود.
 * کاربر (۱۴۰۵/۰۸/۱۲): ۲۵ میلیون ۲۵۰ میلیون ثبت شد و هیچ‌کس متوجه نشد.
 */
const ONES = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
const TEENS = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];
const TENS = ["", "", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
const HUNDREDS = ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
const SCALES = ["", "هزار", "میلیون", "میلیارد", "هزار میلیارد"];

function under1000(n) {
  const parts = [];
  const h = Math.floor(n / 100), r = n % 100;
  if (h) parts.push(HUNDREDS[h]);
  if (r >= 10 && r < 20) parts.push(TEENS[r - 10]);
  else {
    const t = Math.floor(r / 10), o = r % 10;
    if (t) parts.push(TENS[t]);
    if (o) parts.push(ONES[o]);
  }
  return parts.join(" و ");
}

/** ۲۵۰٬۰۰۰٬۰۰۰ ⇒ «دویست و پنجاه میلیون». صفر ⇒ «صفر». */
export function numberToWordsFa(value) {
  let n = Math.floor(Math.abs(Number(value) || 0));
  if (!n) return "صفر";
  const groups = [];
  let i = 0;
  while (n > 0 && i < SCALES.length) {
    const g = n % 1000;
    if (g) groups.unshift(g === 1 && i === 1 ? "هزار" : `${under1000(g)}${SCALES[i] ? ` ${SCALES[i]}` : ""}`);
    n = Math.floor(n / 1000);
    i += 1;
  }
  return (Number(value) < 0 ? "منفی " : "") + groups.join(" و ");
}

/** خلاصهٔ کوتاه برای زیرِ فیلد: «دویست و پنجاه میلیون ریال (≈ ۲۵ میلیون تومان)». */
export function moneyWordsFa(rial) {
  const n = Math.round(Number(rial) || 0);
  if (Math.abs(n) < 1000) return "";
  const toman = Math.round(n / 10);
  return `${numberToWordsFa(n)} ریال — ${numberToWordsFa(toman)} تومان`;
}
